import {z as r} from 'zod';

import {ReviewsAnalysisModeEnum} from '../reivew-analysis-const';
import {ReviewRateEnum} from '../review-rate/review-rate-type';
import {sentimentDataSchema, SentimentEnum} from '../review-sentiment/review-sentiment-type';

export const brandCompareSchema = r.object({
    brandId: r.number().nullable(),
    total: r.number(),
    avgRating: r.number(),
    companiesTotal: r.number(),
    reviewsPerCompany: r.number(),
    replied: r.number(),
    avgResponseSpeed: r.number().nullable(),
    sentiment: sentimentDataSchema,
    topSource: r
        .object({
            catalogId: r.number(),
            catalogName: r.string(),
            catalogLogo: r.string(),
        })
        .nullable(),
    nps: r.number(),
    tonalityIndexSimple: r.number(),
});

export type BrandCompareType = r.infer<typeof brandCompareSchema>;

export const brandCompareListSchema = r.array(brandCompareSchema);

export type ReviewsCompetitorBrandsQueryType = {
    mode?: ReviewsAnalysisModeEnum;
    brandIds?: Array<number>;
    companyIds?: Array<number>;
    startDate: string | null;
    endDate: string | null;
    sentiments: Array<SentimentEnum>;
    sources: Array<number>;
    tags: Array<string>;
    phrases: Array<string>;
    topics: Array<string>;
    userTagsIds: Array<number>;
    aspectIds: Array<number>;
    rating: Array<ReviewRateEnum>;
    withAnswers: boolean | null;
    withText: boolean | null;
    ableToReply: boolean | null;
    target: string | null;
    useDeleted: boolean | null;
};
